import type { Product } from 'src/components/restructure/product/types/product'

import { clientStore } from '../../../../../../../../services/axiosInstance'

export async function fetchProductInsurance({
  productIds,
}: {
  productIds: string[]
}): Promise<Product[]> {
  try {
    const requests = productIds.map((id) =>
      clientStore.get('/v1/api/decathlon-pdp/product', {
        params: {
          source: 'website',
          productId: id,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
    )

    const rawResponses = await Promise.all(requests)

    return rawResponses.map((response) => response?.data)
  } catch (error) {
    return []
  }
}
